/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type OptimizeFieldConfigurationSchemePageType from '@jira/site-optimizer__optimize-field-configuration-scheme-page/src/OptimizeFieldConfigurationSchemePage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyOptimizeFieldConfigurationSchemePagePage: LazyComponent<
	typeof OptimizeFieldConfigurationSchemePageType
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof OptimizeFieldConfigurationSchemePageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-jira-admin-pages-optimize-field-configuration-scheme-page", jiraSpaEntry: "async-jira-admin-pages-optimize-field-configuration-scheme-page" */ '@jira/site-optimizer__optimize-field-configuration-scheme-page/src/OptimizeFieldConfigurationSchemePage.tsx'
				),
			),
		{ ssr: false },
	);

export const OptimizeFieldConfigurationSchemePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOptimizeFieldConfigurationSchemePagePage}
		pageId="jira-admin-pages-optimize-field-configuration-scheme-page"
		shouldShowSpinner
	/>
);
